import Dexie, {type EntityTable} from 'dexie';
import {
    Employee,
    EmployeeInline,
    WorkEventKindEnum as KindEnum, WorkdayStatusEnum as StatusEnum,
} from "@src/httpClient/__generated__/Api.ts";

export enum LocalStatus {
    pending = 'pending',
    synced = 'synced',
    failed = 'failed',
}


export interface LocalEvent {
    id?: number
    temp_id?: string
    branch_id?: number
    branch_name?: string
    kind: KindEnum
    recorded_at: string
    longitude?: number | null
    latitude?: number | null
    localStatus: LocalStatus
    employee: EmployeeInline
    idempotency_key: string
}

export interface OutboxItem {
    id?: number;
    entity: 'event';
    payload: LocalEvent;           // включает temp_id
    idempotencyKey: string;
    createdAt: number;
    tryCount: number;
    lastError?: string;
}

const db = new Dexie('events') as Dexie & {
    events: EntityTable<LocalEvent, "id">;
    outbox: EntityTable<OutboxItem, "id">;
};
db.version(3).stores({
    events: '++id, recorded_at, temp_id, localStatus, idempotency_key, employee.id, branch_id', // Primary key and indexed props
    outbox: '++id,entity,op,createdAt'
});

export interface WorkDay {
    id: number
    date: string
    start_time: string | null
    end_time: string | null
    status: StatusEnum
    total_time: string | null
    inconsistent: boolean
    ad_hoc: boolean
    employeeId: number
}

const employeeDb = new Dexie('employee') as Dexie & {
    employee: EntityTable<Employee, "id">;
    workDays: EntityTable<WorkDay, "id">;
};

employeeDb.version(4).stores({
    employee: '++id,id,username,*branches_ids,last_name_kana,first_name_kana',
    workDays: '++id,id,date,employeeId,[employeeId+date]'
});

export const clearLocalDatabase = () => {
    db.events.clear()
    db.outbox.clear()
    employeeDb.employee.clear()
    employeeDb.workDays.clear()
}

export {db, employeeDb};